// src/components/admin/flows/canvas/useDragNode.js
import { useRef, useCallback } from 'react';

const useDragNode = ({ zoom, onPositionChange }) => {
    const isDragging = useRef(false);
    const dragNodeId = useRef(null);
    const dragStart = useRef({ x: 0, y: 0 });
    const nodeStart = useRef({ x: 0, y: 0 });

    const startDrag = useCallback((e, nodeId, currentPosition) => {
        isDragging.current = true;
        dragNodeId.current = nodeId;
        dragStart.current = { x: e.clientX, y: e.clientY };
        nodeStart.current = { ...currentPosition };

        // Prevent text selection while dragging
        document.body.style.userSelect = 'none';
    }, []);

    const updateDrag = useCallback((e) => {
        if (!isDragging.current || !dragNodeId.current) return;

        const dx = (e.clientX - dragStart.current.x) / zoom;
        const dy = (e.clientY - dragStart.current.y) / zoom;

        const newPosition = {
            x: Math.max(0, nodeStart.current.x + dx),
            y: Math.max(0, nodeStart.current.y + dy),
        };

        onPositionChange(dragNodeId.current, newPosition);
    }, [zoom, onPositionChange]);

    const endDrag = useCallback(() => {
        isDragging.current = false;
        dragNodeId.current = null;
        document.body.style.userSelect = '';
    }, []);

    return {
        isDragging: isDragging.current,
        startDrag,
        updateDrag,
        endDrag,
    };
};

export default useDragNode;
